import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Api } from 'lavva.exalushome';
import { ExtaLifeService } from 'lavva.exalushome.extalife';
import { IRdp21ConfigService } from 'lavva.exalushome.extalife/build/js/Devices/DeviceServices/Dimmer/IRdp21ConfigService';
import { LightTransitionTime } from 'lavva.exalushome.extalife/build/js/Devices/DeviceServices/Dimmer/Rdp21ConfigParameters';
import { Rdp21ConfigService } from 'lavva.exalushome.extalife/build/js/Devices/DeviceServices/Dimmer/Rdp21ConfigService';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { SubmitButton } from '../../../../../../components/submit-button';
import { useBackdropContext } from '../../../../../../context/backdrop';
import ConfigurationInput from '../../../device-details/components/configuration-input';
import { useConfigurationService } from '../../../device-details/hooks/use-configuration-service';
import { DimmingTimeParams } from '../../../device-details/types';

type DimmingTimeFormProps = {
  device: IDevice;
  dimmingTime: LightTransitionTime | null;
  channel: IDeviceChannel;
};

const DimmingTimeForm: React.FC<DimmingTimeFormProps> = ({ device, dimmingTime, channel }) => {
  const { t } = useTranslation('device-info');
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const { handleSubmitResponse } = useConfigurationService();
  const form = useForm<DimmingTimeParams>();

  useEffect(() => {
    if (dimmingTime !== null) form.setValue('dimmingTime', dimmingTime);
  }, [dimmingTime]);

  const onSubmit = form.handleSubmit(async (values) => {
    turnOnBackdrop();
    const extaLifeService = Api.Get<ExtaLifeService>(ExtaLifeService.ServiceName);
    const configService = await extaLifeService.GetDeviceServiceByServiceTypeAsync<IRdp21ConfigService>(
      Rdp21ConfigService.ServiceName,
    );

    const result = await configService.SetDimmingTimeAsync(device, channel.Number, values.dimmingTime);
    handleSubmitResponse(result);
    turnOffBackdrop();
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={onSubmit} className="grid-list-24">
        <ConfigurationInput
          name="dimmingTime"
          label={t('exalus.params.OnOffParams.DimmingTime')}
          placeholder={t('exalus.params.OnOffParams.DimmingTime')}
          inputType="number"
          min={1}
          max={31}
        />
        <SubmitButton />
      </form>
    </FormProvider>
  );
};

export default DimmingTimeForm;
